import React from 'react';

interface AutocompleteFormatLKZProps {
  suchvorschlag?: any;
}

export const AutocompleteFormatPLZ = ({
  suchvorschlag,
}: AutocompleteFormatLKZProps) => {
  return (
    suchvorschlag && (
      <span>{`${suchvorschlag['plz']} - ${suchvorschlag['ortsname']}`}</span>
    )
  );
};
